import CryptoJS from 'crypto-js';
import { RESPONSE_ENCRYPTION_KEY } from 'config/variables';
import { SECRET_KEY } from 'config/Firebase/secureFirebase';

export function decryptResponse<T = any>(encryptedPayload: string): T {
  const bytes = CryptoJS.AES.decrypt(encryptedPayload, SECRET_KEY);
  const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedString) as T;
}
